import { useState } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { PasswordProps } from './Password.types';

const usePresenter = (props: PasswordProps) => {
  const {
    className,
    hideTrailingIcon,
    ...otherProps
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  // not adding state flags as they will be added to the input component
  const variantProps = useBuildVariantProps(
    'password',
  );

  return {
    showPassword,
    togglePassword,
    variantProps,
    hideTrailingIcon,
    otherPasswordProps: otherProps,
  };
};

export default usePresenter;